import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  "https://api.magnirauniverse.com";

const API = `${BASE_URL}/api`;
export default function UserPage() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    role: "designer",
  });

  const [users, setUsers] = useState([]);
  const [editId, setEditId] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    const res = await axios.get(`${API}/users`);
    setUsers(res.data || []);
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  /* ================= CREATE / UPDATE ================= */

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (editId) {
        await axios.put(`${API}/users/${editId}`, {
          name: form.name,
          email: form.email,
          role: form.role,
        });
      } else {
        await axios.post(`${API}/users`, form);
      }

      resetForm();
      fetchUsers();
    } catch (err) {
      alert(err.response?.data?.message || "Error saving user");
    }
  };

  const handleEdit = (user) => {
    setForm({
      name: user.name,
      email: user.email,
      password: "",
      role: user.role,
    });
    setEditId(user._id);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this user?")) return;
    await axios.delete(`${API}/users/${id}`);
    fetchUsers();
  };

  const resetForm = () => {
    setForm({
      name: "",
      email: "",
      password: "",
      role: "designer",
    });
    setEditId(null);
  };

  return (
    <div style={containerStyle}>
      {/* ===== TOP BAR ===== */}
      <div style={topBar}>
        <button onClick={() => navigate(-1)} style={backBtn}>
          ← Back
        </button>

        <h1 style={titleStyle}>👥 Team Members</h1>
      </div>

      {/* ================= FORM CARD ================= */}
      <div style={cardStyle}>
        <form onSubmit={handleSubmit} autoComplete="off" style={formStyle}>
          {/* Dummy hidden fields (Chrome autofill fix) */}
          <input type="text" style={{ display: "none" }} />
          <input type="password" style={{ display: "none" }} />

          <input
            name="name"
            placeholder="Full Name"
            value={form.name}
            onChange={handleChange}
            required
            autoComplete="off"
            style={inputStyle}
          />

          <input
            name="email"
            placeholder="Email"
            type="email"
            value={form.email}
            onChange={handleChange}
            required
            autoComplete="new-email"
            style={inputStyle}
          />

          {!editId && (
            <input
              name="password"
              placeholder="Password"
              type="password"
              value={form.password}
              onChange={handleChange}
              required
              autoComplete="new-password"
              style={inputStyle}
            />
          )}

          <select
            name="role"
            value={form.role}
            onChange={handleChange}
            style={inputStyle}
          >
            <option value="admin">Admin</option>
            <option value="designer">Designer</option>
            <option value="studio_head">Studio Head</option>
            <option value="sales_manager">Sales Manager</option>
            <option value="center_head">Center Head</option>
            <option value="project_manager">Project Manager</option>
            <option value="site_engineer">Site Engineer</option>
            <option value="accountant">Accountant</option>
            <option value="head_accountant">Accountant Head</option>
            <option value="marketing">Marketing</option>
          </select>

          <button type="submit" style={saveBtn}>
            {editId ? "Update User" : "+ Add User"}
          </button>

          {editId && (
            <button type="button" onClick={resetForm} style={cancelBtn}>
              Cancel
            </button>
          )}
        </form>
      </div>

      {/* ================= TABLE ================= */}
      <div style={tableCard}>
        <table style={tableStyle}>
          <thead>
            <tr style={headerStyle}>
              <th style={thStyle}>Name</th>
              <th style={thStyle}>Email</th>
              <th style={thStyle}>Role</th>
              <th style={{ ...thStyle, textAlign: "center" }}>Action</th>
            </tr>
          </thead>

          <tbody>
            {users.map((user) => (
              <tr key={user._id} style={rowStyle}>
                <td style={tdStyle}>{user.name}</td>
                <td style={tdStyle}>{user.email}</td>
                <td style={tdStyle}>{user.role}</td>
                <td style={{ ...tdStyle, textAlign: "center" }}>
                  <button onClick={() => handleEdit(user)} style={editBtn}>
                    ✏ Edit
                  </button>

                  <button
                    onClick={() => handleDelete(user._id)}
                    style={deleteBtn}
                  >
                    🗑 Delete
                  </button>
                </td>
              </tr>
            ))}

            {users.length === 0 && (
              <tr>
                <td
                  colSpan="4"
                  style={{ textAlign: "center", padding: "20px" }}
                >
                  No users found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

/* ================= STYLES ================= */

const containerStyle = {
  padding: "40px",
  background: "#f5f7fa",
  minHeight: "100vh",
};

const titleStyle = {
  marginBottom: "25px",
  fontSize: "26px",
};

const cardStyle = {
  background: "#fff",
  padding: "25px",
  borderRadius: "12px",
  boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
  marginBottom: "30px",
};

const formStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
  gap: "15px",
};

const inputStyle = {
  padding: "10px",
  borderRadius: "8px",
  border: "1px solid #d1d5db",
  fontSize: "14px",
};

const saveBtn = {
  background: "#4a2ea6",
  color: "#fff",
  border: "none",
  borderRadius: "8px",
  cursor: "pointer",
  padding: "10px",
};

const cancelBtn = {
  background: "#6b7280",
  color: "#fff",
  border: "none",
  borderRadius: "8px",
  cursor: "pointer",
  padding: "10px",
};

const tableCard = {
  background: "#fff",
  borderRadius: "12px",
  boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
  overflow: "hidden",
};

const tableStyle = {
  width: "100%",
  borderCollapse: "collapse",
};

const headerStyle = {
  background: "#2d2f63",
  color: "#fff",
};

const thStyle = {
  padding: "14px",
  textAlign: "left",
};

const rowStyle = {
  transition: "background 0.2s",
};

const tdStyle = {
  padding: "14px",
  borderBottom: "1px solid #eee",
};

const editBtn = {
  marginRight: "10px",
  background: "#3b82f6",
  color: "#fff",
  border: "none",
  padding: "6px 12px",
  borderRadius: "6px",
  cursor: "pointer",
};

const deleteBtn = {
  background: "#ef4444",
  color: "#fff",
  border: "none",
  padding: "6px 12px",
  borderRadius: "6px",
  cursor: "pointer",
};
const topBar = {
  display: "flex",
  alignItems: "center",
  gap: "20px",
  marginBottom: "25px",
};

const backBtn = {
  background: "#0A5F59",
  color: "#fff",
  border: "none",
  padding: "8px 16px",
  borderRadius: "8px",
  cursor: "pointer",
  fontSize: "14px",
  fontWeight: "500",
  transition: "0.2s",
};
